import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  Card,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoGrey,
  InfoGreen,
} from './styled'
import vector from 'assets/Vector6.png'

interface Props {
  result: string
  equivalentValue: string
  savedMoney: string
}

export const MetricsSubTab1: FC<Props> = ({ result, equivalentValue, savedMoney }) => {
  const state = useSelector(staticSelector)

  const { title, iconLeft, iconRight, textLeft, textRight } = state.content?.nationalMetric.subTabRender[0]

  return (
    <Container>
      <Content>
        {title ? <Title>{title}</Title> : null}
        <Card>
          <Left>
            <LeftIconContainer>{iconLeft.url ? <Icon src={iconLeft.url} /> : null}</LeftIconContainer>
            <TextContainer>
              {result && savedMoney ? (
                <>
                  {' '}
                  <Info>
                    <InfoGrey>{result} lbs of CO2</InfoGrey>
                    Total $ savings of <InfoGrey>${savedMoney}.</InfoGrey>
                  </Info>
                </>
              ) : null}
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer>{iconRight.url ? <Icon src={iconRight.url} /> : null}</RightIconContainer>
            <TextContainer>
              {equivalentValue ? (
                <Info>
                  That’s the equivalent of <InfoGreen>planting {equivalentValue} acres</InfoGreen> of urban trees
                </Info>
              ) : null}
            </TextContainer>
          </Right>
        </Card>
      </Content>
    </Container>
  )
}
